'use client';
import Typography from '@/components/shared/typography/typography.component';
import SwipeableDrawer from '@/components/shared/bottom-sheet/bottom-sheet.component';

import { useState } from 'react';
import { IFormatedData_SELL, useTranslation } from '@/hook';
import { BlueHomeIcon, SylndrS } from '../../../../public/Images';
import {
    EInspectionType,
    ISellCarForm,
    TInspectionType,
    TStepperPath,
} from '@/types';

import styles from './styles.module.scss';
import InspectionButtonMobile from '../inspection-type/inspection-type.component';
import SylndrHubLocationButtonMobile from '../sylndr-hub-location/sylndr-hub-location-button-mobile/sylndr-hub-loaction-button-mobile.component';
import SylndrHubLocation from '../sylndr-hub-location/sylndr-hub-location';

interface ISelectInspectionType {
    // label: string;
    path: TStepperPath;
    formFunction: (
        key: keyof ISellCarForm,
        clickedItem: IFormatedData_SELL
    ) => void;
}

const SelectInspectionType = ({
    // label,
    path,
    formFunction,
}: ISelectInspectionType) => {
    const { t, i18n } = useTranslation();

    const [selectedInspectionType, setSelectedInspectionType] =
        useState<TInspectionType>();
    const [openDirectionModal, setOpenDirectionModal] = useState(false);

    const toggleDirectionModal = () => {
        setOpenDirectionModal(!openDirectionModal);
    };

    const handleConfirm = () => {
        if (!selectedInspectionType) return;
        const tEn = i18n.getFixedT('en');
        const tAr = i18n.getFixedT('ar');
        const inspectionObj: IFormatedData_SELL = {
            nameEn: tEn(selectedInspectionType),
            nameAr: tAr(selectedInspectionType),
            icon: '',
            inShoppingList: path === 'path1',
            id: selectedInspectionType,
            selected: true,
        };

        formFunction('inspectionType', inspectionObj);
    };

    const formFunctionBridge = (id: string) => {
        setSelectedInspectionType(id as TInspectionType);
    };
    return (
        <div>
            <div className={styles.select_input_group}>
                {/* <Typography color={'#344054'} variant="caption">
          {label}
        </Typography> */}
            </div>
            <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
                <InspectionButtonMobile
                    id={EInspectionType.HOME}
                    header={t('InspectionAtHomeMobile')}
                    subHeader={t('24HoursOffer')}
                    img={BlueHomeIcon.src}
                    btnClick={formFunctionBridge}
                    selected={selectedInspectionType === EInspectionType.HOME}
                />
                <InspectionButtonMobile
                    id={EInspectionType.WAREHOUSE}
                    header={t('InspectionAtSylndrHubMobile')}
                    subHeader={t('sellFormWinVoucher')}
                    img={SylndrS.src}
                    // tag={t('New') as string}
                    btnClick={formFunctionBridge}
                    selected={
                        selectedInspectionType === EInspectionType.WAREHOUSE
                    }
                />
            </div>
            {selectedInspectionType === EInspectionType.WAREHOUSE && (
                <SylndrHubLocationButtonMobile
                    sylndrHubLocationButton={toggleDirectionModal}
                />
            )}
            <div className={styles.button_container}>
                <button
                    className="sylndr_button primary"
                    style={{ height: '48px' }}
                    onClick={() => handleConfirm()}
                    disabled={!selectedInspectionType}
                >
                    <Typography>{t('continue')}</Typography>
                </button>
            </div>
            <SwipeableDrawer
                open={openDirectionModal}
                setOpen={setOpenDirectionModal}
            >
                <SylndrHubLocation closeModal={toggleDirectionModal} />
            </SwipeableDrawer>
        </div>
    );
};
export default SelectInspectionType;
